import React, {Component} from 'react';

import './RemedialTrainingResponse.scss';
import CustomForm from "../../../../shared/components/form/CustomForm";
import {validateRequired} from "../../../../shared/components/form/ValidationFunctions";
import classNames from 'classnames'

class DailyPatrolLogResponse extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFormOpened: false,
      editingLogIndex: null,
    }
  }

  get value() {
    return this.props.value && this.props.value.list || []
  }

  get isEdit() {
    return this.props.isEdit !== false
  }

  get formConfig() {
    return {
      fields: {
        type: {
          type: 'text',
          label: 'Type',
          rules: [validateRequired('Type')]
        },
        location: {
          type: 'text',
          label: 'Location',
          rules: [validateRequired('Location')]
        },
        activity: {
          type: 'text',
          label: 'Activity',
          rules: [validateRequired('Activity')]
        },
        action: {
          type: 'text',
          label: 'Action',
          rules: [validateRequired('Action')]
        },
      }
    }
  }

  componentDidMount() {
    this.props.onValueChange && this.props.onValueChange(this.props.name, {
      ...this.props.value,
      isValid: true,
    });
  }

  openForm() {
    this.setState({
      isFormOpened: true
    })
  }

  onAddLog(log) {
    if(!this.state.editingLogIndex) {
      this.props.onValueChange(this.props.name, {
        ...this.props.value,
        isValid: true,
        list: [...this.value, log]
      });
      this.setState({
        isFormOpened: false
      })
    } else {
      this.props.onValueChange(this.props.name, {
        ...this.props.value,
        isValid: true,
        list: this.value.map((v, i) => i === this.state.editingLogIndex? log: v)
      });
      this.setState({
        isFormOpened: false,
        editingLogIndex: null
      })
    }
  }

  removeItem(index) {
    let copyVal = [...this.value];
    copyVal.splice(index, 1);
    this.props.onValueChange(this.props.name, {
      ...this.props.value,
      isValid: true,
      list: copyVal
    })
  }

  editItem(index) {
   this.setState({
     editingLogIndex: index
   }, () => {
     this.openForm()
   })
  }

  get editingLog() {
    let copyVal = [...this.value];
    return copyVal[this.state.editingLogIndex]
  }

  render() {
    return (
      <div className={classNames({"remedial-training-response": true, 'preview': !this.isEdit})}>
        <div className="remedial-training-title">
          {this.props.element.title_label}
        </div>
        {this.value.map((val, index) => (
          <div className="remedial-training-response-item" key={val.name}>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.type_label}
              </div>
              <div className="rt-value">
                {val.type}
              </div>
            </div>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.activity_label}
              </div>
              <div className="rt-value">
                {val.activity}
              </div>
            </div>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.location_label}
              </div>
              <div className="rt-value">
                {val.location}
              </div>
            </div>
            <div className="rt-item">
              <div className="rt-name">
                {this.props.element.action_label}
              </div>
              <div className="rt-value">
                {val.action}
              </div>
            </div>
            {this.isEdit && (
              <div className="rt-item">
                <button className="button danger small" type="button" onClick={() => this.removeItem(index)}>
                  <i className="fa fa-trash"/> Delete log
                </button>
                <button className="button secondary small" type="button" onClick={() => this.editItem(index)}>
                  <i className="fa fa-edit"/> Edit log
                </button>
              </div>
            )}
          </div>
        ))}
        {
          !this.state.isFormOpened && this.isEdit && (
            <div className="text-right add-rt">
              <button className="button primary small" type="button" onClick={() => this.openForm()}>
                <i className="fa fa-plus"/> Add log
              </button>
            </div>
          )
        }

        {this.state.isFormOpened && this.isEdit && (
          <div>
            <CustomForm
              config={this.formConfig}
              saveLabel={'Add'}
              saveIcon={'fa fa-plus'}
              saveSmall={true}
              initialValues={this.editingLog}
              onSubmit={(log) => this.onAddLog(log)}
            />
          </div>
        )}
      </div>
    )
  }
}

export default DailyPatrolLogResponse;
